<script setup lang="ts">
defineProps({
	// Target to trigger the infinite loading event
	// https://vue3-infinite-loading.netlify.app/api/props.html#target
	target: {
		type: [String, Object],
		default: undefined,
	},
	// Distance from the bottom to trigger the infinite loading event
	// https://vue3-infinite-loading.netlify.app/api/props.html#distance
	distance: {
		type: Number,
		default: 0,
	},
	// Identifier to reset the component
	// https://vue3-infinite-loading.netlify.app/api/props.html#identifier
	identifier: {
		type: [String, Number, Boolean],
		default: undefined,
	},
	// Direction of the scroll
	// https://vue3-infinite-loading.netlify.app/api/props.html#direction
	direction: {
		type: String,
		default: 'bottom',
		validator: (value: string) => ['top', 'bottom'].includes(value),
	},
	firstload: {
		type: Boolean,
		default: true,
	},
});

const emit = defineEmits<{ (e: 'infinite', event: InfiniteLoadingEvent): void }>();

function handleInfinite(event: InfiniteLoadingEvent) {
	emit('infinite', event);
}
</script>

<template>
	<InfiniteLoading
		v-bind="$attrs"
		class="infinite-loading"
		:target="target"
		:identifier="identifier"
		:distance="distance"
		:direction="direction"
		:firstload="firstload"
		@infinite="handleInfinite"
	>
		<template #complete>
			<slot name="complete" />
		</template>
		<template #spinner>
			<slot name="spinner" />
		</template>
	</InfiniteLoading>
</template>

<style lang="scss" scoped>
.infinite-loading {
	height: 100%;
}
</style>
